/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Property_Registry_Cee_Lookup_PaidInputs */

const cs_property_registry_cee_lookup_paid = /** @type {(inputs: Property_Registry_Cee_Lookup_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zkontrolovat CEE (${i?.credits} kr.)`)
};

const en_property_registry_cee_lookup_paid = /** @type {(inputs: Property_Registry_Cee_Lookup_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check CEE (${i?.credits} cr.)`)
};

/**
* | output |
* | --- |
* | "Check CEE ({credits} cr.)" |
*
* @param {Property_Registry_Cee_Lookup_PaidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_lookup_paid = /** @type {((inputs: Property_Registry_Cee_Lookup_PaidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_Lookup_PaidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_lookup_paid(inputs)
	return cs_property_registry_cee_lookup_paid(inputs)
});